import React from "react";
import AdminNavbar from "../Navbars/AdminNavbar.js";
import Sidebar from "../../components/Sidebar/Sidebar.js";

import routes from "../../routes/portalRoutes.js";
import Error from "../error/error";
import {withLocalize} from "react-localize-redux";
import {connect} from "react-redux";
import * as Roles from "../../store/actions/roles";
import * as actions from "../../store/actions/actions";
import IdleTimer from 'react-idle-timer'

class Admin extends React.PureComponent {
    constructor(props){
        super(props)

        this.state = {
            timeout: 900000
        }
    }

    // componentDidMount() {
    //     window.addEventListener('*', this._onAction);
    // }

    componentDidUpdate(e) {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.mainContent.scrollTop = 0;
    }
    // getRoutes = routes => {
    //   return routes.map((prop, key) => {
    //     if (prop.layout === "/admin") {
    //       return (
    //         <Route
    //           path={prop.path}
    //           component={prop.component}
    //           key={key}
    //         />
    //       );
    //     } else {
    //       return null;
    //     }
    //   });
    // };
    getBrandText = path => {
        for (let i = 0; i < routes.length; i++) {
            if (
                this.props.location.pathname.indexOf(
                    routes[i].layout + routes[i].path
                ) !== -1
            ) {
                return routes[i].name;
            }
        }
        return "Brand";
    };

    handleOnAction = (event) => {
        if (null !== this.idleTimer && 'undefined' !== this.idleTimer)
            new Date().getTime() - this.idleTimer.getLastActiveTime() > (900000) ? this.props.logout() : this.idleTimer.reset();
    }

    handleOnActive = (event) => {
        new Date().getTime() - this.idleTimer.getLastActiveTime() > (900000) ? this.props.logout() : this.idleTimer.reset();
    }

    handleOnIdle = (event) => {
        this.props.logout()
    }


    render() {
        let originalLogo = this.props.bankLogo !== null ? this.props.bankLogo.substring(this.props.bankLogo.indexOf('data')) : null;
        let logo = Roles.isBankAndCorporateUser(this.props.role) === true ?
            <Sidebar
                {...this.props}
                routes={routes}
                logo={{
                    innerLink: "/index",
                    imgSrc: originalLogo,
                    imgAlt: "..."
                }}
            />
            // <div className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
            //     <img alt="" onClick={this.onLogoClick} src={this.props.bankLogo} width="250" className="img-rounded"/>
            // </div>
            :
            <Sidebar
                {...this.props}
                routes={routes}
                logo={{
                    innerLink: "/index",
                    imgSrc: require("../../assets/img/brand/plick-logo.png"),
                    imgAlt: "..."
                }}
            />;



        return (
            <>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    timeout={900000}
                    onActive={this.handleOnActive}
                    onIdle={this.handleOnIdle}
                    onAction={this.handleOnAction}
                    debounce={250}
                />
                {logo}
                <div className="main-content" ref="mainContent">
                    <AdminNavbar
                        {...this.props}
                        // brandText={this.getBrandText(this.props.location.pathname)}
                    />
                    <Error>
                    {/*<div>*/}
                        {this.props.children}
                        {/*<Progress></Progress>*/}
                    {/*</div>*/}
                    </Error>
                    {/*<Switch>*/}
                    {/*  {this.getRoutes(routes)}*/}
                    {/*  <Redirect from="*" to="/admin/index" />*/}
                    {/*</Switch>*/}
                    {/*<Container fluid style={{'padding-bottom':'60px'}}>*/}
                    {/*    <div style={{position:"relative",'min-height':'50vh'}}>*/}
                    {/*        <AdminFooter />*/}
                    {/*    </div>*/}
                    {/*</Container>*/}
                </div>
            </>
        );
    }
}
const mapStateToProps = state => {
    return {
        bankLogo:state.authentication.authenticatedUser.bankLogo,
        role:state.authentication.authenticatedUser.role
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch({ type: actions.AUTHENTICATION_LOGOUT_REQUEST})
    }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Admin));
